export default "__VITE_ASSET__504d4ae1__"